"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("../util");
const { GET } = util_1.httpMethods;
/**
 * @classdesc Represents the class interfacing lures related API-I endpoints
 * @class
 */
class Lures {
    constructor(api) {
        this.api = api;
    }
    /**
     * Get lures according to the parameters provided
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#lures-get}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an object of data or an error with the problem
     */
    async getLures(args) {
        const { deactivated } = args || {};
        const methodName = 'getLures';
        // validate
        const validations = [(0, util_1.validateParam)(methodName, 'deactivated', deactivated, util_1.ValidationTypes.BOOLEAN)];
        (0, util_1.validateParams)(validations);
        const route = '/lures';
        const input = {
            query: {
                deactivated,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(GET, route, formattedInput);
    }
}
exports.default = Lures;
//# sourceMappingURL=lures.js.map